export default {
	props: {
		label		: {
			type: String,
			default: 'Submit'
		},
		progress	: {
			type: Boolean,
			default: false
		},
		disabled	: {
			type: Boolean,
			default: false
		},
		loaderColor	: {
			type: String,
			default: 'white'
		},
		type		: {
			type: String,
			default: 'submit'
		},
		color		: {
			type: String,
			default: 'black'
		},
		loader		: {
			type		: String,
			default		: 'default'
		}
	},
	methods: {
		changeEvent() {
			this.$emit('change-event')
		}
	}
}
